import apiClient from "./axios";
import { ApiResponse, PaginatedResponse } from "../types";

export type RiskSeverity = "low" | "medium" | "high" | "critical";
export type RiskCategory = "security" | "fraud";
export type RiskEventType =
  | "login_failed"
  | "login_new_device"
  | "credential_reset"
  | "transfer_initiated"
  | "inbound_credit"
  | "beneficiary_added";

export interface RiskEvent {
  id: string;
  type: RiskEventType;
  category: RiskCategory;
  severity: RiskSeverity;
  score: number;
  userId: string | null;
  reasons: string[];
  metadata: Record<string, unknown> | null;
  createdAt: string;
}

export interface RiskSummary {
  sinceDays: number;
  total: number;
  bySeverity: Partial<Record<RiskSeverity, number>>;
  byCategory: Partial<Record<RiskCategory, number>>;
}

export interface GetRiskEventsParams {
  severity?: RiskSeverity;
  category?: RiskCategory;
  type?: RiskEventType;
  userId?: string;
  page?: number;
  limit?: number;
}

export const fraudApi = {
  getEvents: async (params: GetRiskEventsParams = {}) => {
    const { data } = await apiClient.get<
      ApiResponse<PaginatedResponse<RiskEvent>>
    >("/admin/fraud/events", { params });
    return data.data;
  },
  getSummary: async (sinceDays = 7) => {
    const { data } = await apiClient.get<ApiResponse<RiskSummary>>(
      "/admin/fraud/summary",
      { params: { sinceDays } }
    );
    return data.data;
  },
};
